import { Route, Routes } from 'react-router-dom';
import SelfService from './index';
import AuthenticatorList from './containers/AuthenticatorList';
import Enroll from './containers/Enroll';
import FaceCaptureLayout from './containers/FaceCaptureLayout';
import Consent from './containers/Consent';

export enum SelfServicePath {
  SELF_SERVICE_LANDING_PAGE = '/self-service',
  SELF_SERVICE_ENROLL_FACE = '/face/enroll',
  SELF_SERVICE_CONSENT_FACE = '/face/consent',
}

const SelfServiceRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<SelfService />}>
        <Route index element={<AuthenticatorList />} />
        <Route path="/face" element={<FaceCaptureLayout />}>
          <Route index path={SelfServicePath.SELF_SERVICE_ENROLL_FACE} element={<Enroll />} />
          <Route path={SelfServicePath.SELF_SERVICE_CONSENT_FACE} element={<Consent />} />
        </Route>
      </Route>
    </Routes>
  );
};

export default SelfServiceRoutes;
